import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { createAction } from 'redux-actions';

export const DIALOG_TYPE = 'FIRST_TIME_USE_DIALOG';

export const spendingPlanFirstTimeUse = createAction(rootUiActions.createDialog.toString(), () =>
  rootUiTypes.mkRootUiData({
    type: DIALOG_TYPE,
  }),
);
